import { render, staticRenderFns } from "./ProcesionesView.vue?vue&type=template&id=bad83e7c"
import script from "./ProcesionesView.vue?vue&type=script&lang=js"
export * from "./ProcesionesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports